export default "__VITE_ASSET__38ae47fc__"